import { Typography, Grid2, Button, Box } from "@mui/material"
import Styles from "./FaqButtonList.module.css"
import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom"
import axios from "axios";
import { backendHosts } from "../../../ui-utils/apiConfig"

function slugify(title) {
    return title
        .toLowerCase()
        .replace(/[^\w\s-]/g, "")
        .replace(/\s+/g, "-")
        .replace(/-+/g, "-")
        .replace(/^-+|-+$/g, "");
}


export default function FaqButtonList() {

    const navigate = useNavigate();

    const [categories, setCategories] = useState([])


    useEffect(() => {

        (async () => {

            try {

                localStorage.removeItem("categoryId")
                localStorage.removeItem("subcategoryId")
                const result = await axios.get(`${backendHosts.ADMIN}/api/faqs/categories`)
                console.log("categoriess button")

                if (result.data.status == 200) {
                    const subResults = result.data?.categories
                    setCategories(subResults)
                } else {
                    console.log("Error in fetching category list API: ", result)
                }

            } catch (error) {
                console.log("Error in fetching category list API: ", error)
            }
        })()
    }, [])

    const handleCategoryClick = (category) => {
        const slug = slugify(category.name)

        navigate(`/support/faqs/${slug}`, {
            state: { categoryId: category.id }
        });
        localStorage.setItem("category", category.name);
    }



    return (
        <>
            <Grid2 className={Styles.outerCard} >
                <Box sx={{ maxWidth: '1400px', margin: '0 auto' }}>
                    <Grid2 container className={Styles.w_cat_list} sx={{ py: 5 }} spacing={4}>

                        {categories.map((category, index) => (
                            <Grid2 item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
                                <Box className={Styles.cardWrapper} sx={{ width: "fit-content" }}>

                                <Button
                                    fullWidth
                                    variant="outlined"
                                    onClick={() => {
                                        handleCategoryClick(category)

                                    }}
                                    sx={{
                                        height: '93px',
                                        width: "282px",
                                        color: '#000000',
                                        borderRadius: '12px',
                                        textTransform: 'none',
                                        // borderColor: selectedCategory === category.name ? '#fff' : '#2D333C',
                                        backgroundColor: "#FFF4D866",
                                        boxShadow: "0px 4px 62px 0px #0000001F",
                                        transition: 'all 0.4s ease',
                                        borderColor: '#fff',
                                        borderRadius: "16px",
                                        fontSize: 'calc(20px + var(--font-delta))',
                                        fontFamily: 'Inter400',
                                        overflow: 'hidden',
                                        position: 'relative', zIndex: 2,
                                        '&:hover': {
                                            background: 'linear-gradient(252.52deg, #110A0A 9.37%, #2D1F1C 47.3%, #2F2F0A 73.59%, #171346 99.03%)',
                                            boxShadow: "0px 4px 4px 0px #E8B889",
                                            color: '#ffffff',

                                        },

                                    }}
                                >
                                        <span className={Styles.circleBackground}></span>
                                        <span style={{ position: 'relative', zIndex: 3 }}>{category.name}</span>
                                    {/* {category.name} */}
                                </Button>
                                </Box>
                            </Grid2>
                        ))}

                    </Grid2>

                </Box>
            </Grid2>
        </>
    )
}